import { render, staticRenderFns } from "./WorkRecordFilterModal.vue?vue&type=template&id=1587f97b&scoped=true"
import script from "./WorkRecordFilterModal.vue?vue&type=script&lang=js"
export * from "./WorkRecordFilterModal.vue?vue&type=script&lang=js"
import style0 from "./WorkRecordFilterModal.vue?vue&type=style&index=0&id=1587f97b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1587f97b",
  null
  
)

export default component.exports